<div class="container-fluid">
	<div class="row">
		<div class="col-sm-12">
			<ng-content></ng-content>
		</div>
	</div>
</div>
